import { storeToRefs } from "pinia"
import { useAuthStore, useAuthStore } from "~/store/auth"

export default defineNuxtRouteMiddleware((to) => {
  const { authenticated } = storeToRefs(useAuthStore()) // make authenticated state reactive
  const authStore = useAuthStore() // use authenticateUser action from  auth store
  const uuid =  authStore.getUid

  if (uuid !== 0) {
    // check if value exists
    authenticated.value = true // update the state to authenticated
  }

  // if token exists and url is /login redirect to homepage
  if (uuid !== 0 && to?.name === "login") {
    return navigateTo("/")
  }

  // if token doesn't exist redirect to log in
  if (uuid === 0 && to?.name !== "login") {
    abortNavigation()
    return navigateTo("/login")
  }
})
